import AntDButton, { ButtonProps } from 'antd/lib/button';
import styled from 'styled-components';
import theme from '@css/theme';
import { is, isNot } from 'typescript-styled-is';

interface DefaultButtonProps {
  height?: 'l';
}

const DefaultButton = styled(AntDButton)<DefaultButtonProps & ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  ${is('height')`
    height: ${({ height }) => (height === 'l' ? '54px' : '24px')}
  `}
  padding: 8px 16px;
  line-height: 19px;
  background-color: ${({ color }) => color || '#FFFFFF'};
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  outline: none;
`;

export const Primary = styled(DefaultButton)`
  background-color: ${theme.button.primary.color};
  border-color: ${theme.button.primary.color};
  color: ${theme.color.white};
  ${is('disabled')`
    opacity: 0.5;
    background-color: ${theme.button.primary.color} !important;
    border-color: ${theme.button.primary.color} !important;
    color: ${theme.color.white} !important;
  `};
  ${isNot('disabled')`  
    &:hover {
      color: ${theme.color.white};
      background-color: ${theme.button.primary.hover};
      border-color: ${theme.button.primary.hover};
      opacity: 0.8;
      outline: none;
    }
    background-color: ${theme.button.primary.color} !important;
    border-color: ${theme.button.primary.color} !important;
    color: ${theme.color.white} !important;
  `}
`;

export const Secondary = styled(DefaultButton)`
  background-color: ${theme.color.white};
  border: ${theme.button.secondary.border};
  color: ${theme.color.neutral1};
  &:hover,
  &:focus {
    color: ${theme.color.neutral1};
    background-color: ${theme.color.white};
    border: ${theme.button.secondary.border};
    opacity: 0.8;
    outline: none;
  }
`;

export const DeletePrimary = styled(DefaultButton)`
  color: ${theme.color.white};
  background-color: ${theme.button.delete.color};
  border: ${theme.button.delete.border};
  &:hover,
  &:focus {
    color: ${theme.color.white};
    background-color: ${theme.button.delete.color};
    border: ${theme.button.delete.border};
    opacity: 0.8;
    outline: none;
  }
`;

export const DeleteOutlined = styled(DefaultButton)`
  color: ${theme.button.delete.color};
  border: ${theme.button.delete.border};
  &:hover,
  &:focus {
    border: ${theme.button.delete.border};
    color: ${theme.button.delete.color};
    background-color: #f9e9e8;
    outline: none;
  }
`;

export const TextPrimary = styled.span`
  color: ${theme.button.primary.color} !important;
  margin: 0;
  padding: 0 4px;
  &:hover,
  &:focus {
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: ${theme.button.primary.color};
  }
  ${is('disabled')`
    opacity: 0.5;
    pointer-events: none;
  `};
`;

export const TextSecondary = styled.span`
  color: ${theme.color.neutral1} !important;
  margin: 0;
  padding: 0 4px;
  &:hover,
  &:focus {
    cursor: pointer;
  }
`;

export const TextDelete = styled.span`
  color: ${theme.button.delete.color} !important;
  margin: 0;
  padding: 0 4px;
  &:hover,
  &:focus {
    cursor: pointer;
    text-decoration-color: ${theme.button.delete.color};
    text-decoration: underline;
  }
`;
